import {
  Delete,
  Get,
  getAPIUrl,
  Post,
  PostFormData,
  Put,
} from "../../../services/apiMethod";

export const BannerEndpoints = {
  getBannerDetails: `/admin/getBanners?`,
  updateRequestStatus: `/admin/common/action-on-request`,
  addBanner: `/admin/addBanner`,
  editBanner: `/admin/updateBanner?bannerId=`,
  deleteBanner: `/admin/deleteBanner?bannerId=`,
};

export const getBannerDetails = (param = "") => {
  const url = getAPIUrl(BannerEndpoints.getBannerDetails, param);
  return Get(url);
};

export const editBanner = (data, param = "") => {
  const url = getAPIUrl(BannerEndpoints.editBanner, param);
  return PostFormData(url, data, true);
};
export const updateRequestStatus = (data, param = "") => {
  const url = getAPIUrl(BannerEndpoints.updateRequestStatus, param);
  return Put(url, data);
};


export const deleteBanner = (param = "") => {
  const url = getAPIUrl(BannerEndpoints.deleteBanner, param);
  return Delete(url, param);
};
export const addBanner = (data, param = "") => {
  const url = getAPIUrl(BannerEndpoints.addBanner, param);
  return PostFormData(url, data, true);
};
